export default function CArrays() {
  return <h2>C Arrays</h2>;
}
